import React, { useEffect, useState, useRef } from "react";
import "./roadmap.scss";

const images = [
  "/assets/roadmapassets/roadmapone.png",
  "/assets/roadmapassets/roadmaptwo.png",
  "/assets/roadmapassets/roadmapthree.png",
  "/assets/roadmapassets/roadmapfour.png",
  "/assets/roadmapassets/roadmapfive.png",
  "/assets/roadmapassets/roadmapsix.png",
  "/assets/roadmapassets/roadmapseven.png",
];
const circlePositions = [0, 300, 580, 848, 1190, 1460, 1753];

const Sevenphases = () => {
  const [activePhase, setActivePhase] = useState(0);
  const roadmapRef = useRef(null);
  const thumbRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!roadmapRef.current || !thumbRef.current) return;
  
      const sectionTop = roadmapRef.current.offsetTop;
      const sectionHeight = roadmapRef.current.offsetHeight;
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;
  
      // Calculate progress relative to the roadmap section
      let progress = (scrollY - sectionTop) / (sectionHeight - viewportHeight);
      progress = Math.min(Math.max(progress, 0), 1); // Clamp between 0 and 1
  
      // Extend thumb position by 300px
      const minThumbPosition = circlePositions[0]; // First position
      const maxThumbPosition = circlePositions[circlePositions.length - 1] + 205; // Add 300px
      const thumbPosition = minThumbPosition + progress * (maxThumbPosition - minThumbPosition);
  
      // Update thumb position
      thumbRef.current.style.top = `${thumbPosition}px`;
  
      // Detect closest phase dynamically
      let closestPhase = 0;
      for (let i = 0; i < circlePositions.length; i++) {
        if (thumbPosition >= circlePositions[i]) {
          closestPhase = i;
        }
      }
  
      setActivePhase(closestPhase);
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  

  return (
    <section className="sevenphasesmain" ref={roadmapRef}>
      <h4 className="sevenphaseshead">The Seven Phases</h4>
      <div className="innersevenphases">
        {/* Image Container */}
        <div className="mainphasesimg">
          <div className="phasesimg">
            <img src={images[activePhase]} alt={`Phase ${activePhase + 1}`} className="innerphasesimg  d-noneonmobile" />
            <img src='/assets/roadmapassets/roadmapone.png' className="innerphasesimg d-blockonmobile d-none" />
          </div>
        </div>

        {/* Scroll Track */}
        <div className="scrollermain">
          <span className="thumb" ref={thumbRef}></span>
          {Array.from({ length: 7 }).map((_, index) => (
            <span key={index} className={`circle circle${index + 1}`}></span>
          ))}
        </div>

        {/* Text Phases */}
        <div className="phasestextsmain">
            <div className="phasestext">
              <p className="phasepara">Phase 1 (Q1 2025)</p>
              <h4 className="phasehead">Foundational Features</h4>
              <ul>
                <li>
                  Launching decentralized chat for secure, encrypted
                  communication
                </li>
                <li>
                  Peer-to-peer payments for seamless digital asset transactions
                </li>
              </ul>
            </div>
            <div className="phasestext">
              <p className="phasepara">Phase 2 (Q2 2025)</p>
              <h4 className="phasehead">Advanced Group Features</h4>
              <ul>
                <li>
                Fully encrypted secure group chats
                </li>
                <li>
                Enhanced group management tools with advanced permission controls
                </li>
              </ul>
            </div>
            <div className="phasestext">
              <p className="phasepara">Phase 3 (Q3 2025)</p>
              <h4 className="phasehead">Customizable User Profiles</h4>
              <ul>
                <li>
                Rollout of user profiles with customizable public and private modes for personalized experiences.
                </li>
              </ul>
            </div>
            <div className="phasestext">
              <p className="phasepara">Phase 4 (Q4 2025)</p>
              <h4 className="phasehead">Privacy-Focused Browsing</h4>
              <ul>
                <li>
                Launch of a secure decentralized browser with a built-in VPN for anonymous and censorship-free access.
                </li>
                <li>
                Integration with Storage for the backup of the files (image, PDF, video etc) and messages in the chat.
                </li>
              </ul>
            </div>
            <div className="phasestext">
              <p className="phasepara">Phase 5 (Q1 2026)</p>
              <h4 className="phasehead">Web3 Governance Tools</h4>
              <ul>
                <li>
                Integration of decentralized governance capabilities and DAO tools to empower community decision-making.
                </li>
              </ul>
            </div>
            <div className="phasestext">
              <p className="phasepara">Phase 6 (Q2 2026)</p>
              <h4 className="phasehead">Developer Ecosystem</h4>
              <ul>
                <li>
                Introduction of a developer portal with tools for building decentralized apps, including SDKs and open-source integration capabilities.
                </li>
              </ul>
            </div>
            <div className="phasestext">
              <p className="phasepara">Phase 7 (Q3 2026)</p>
              <h4 className="phasehead">Enhanced Communication</h4>
              <ul>
                <li>
                Decentralized voice call functionality and support for individual and group video calls to improve collaboration.
                </li>
              </ul>
            </div>
          </div>
      </div>
    </section>
  );
};

export default Sevenphases;
